import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Button, Flex, Modal } from "antd"
import { WarningOutlined } from "@ant-design/icons"
import styles from "../../index.module.css"

const ConfirmModal = ({ open, title, description, confirmLabel, onConfirm, onCancel, confirmLoading = false }) => {
  const { t } = useTranslation()

  return (
    <Modal open={open} onCancel={onCancel} footer={null} centered width={360}>
      <Flex vertical align="flex-start" gap={12} className={styles.modalContent}>
        <WarningOutlined className={styles.modalWarningIcon} />
        <span className={styles.modalTitle}>{title}</span>
        <p className={styles.modalDesc}>{description}</p>
        <Flex gap={8} className={styles.modalActions}>
          <Button onClick={onCancel} disabled={confirmLoading}>{t("global.cancel")}</Button>
          <Button type="primary" onClick={onConfirm} loading={confirmLoading}>
            {confirmLabel}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  confirmLoading: PropTypes.bool
}

export default ConfirmModal
